<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="atendBlocoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Atendimento em Grupo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row" v-if="!assistencia">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    :compact="true"
                                    v-model="inicio" 
                                    required
                                    :validate="validate"
                                    label="Início" 
                                    :edicao="!anamnese"
                                    type="time" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    :compact="true"
                                    required
                                    :validate="validate"
                                    v-model="fim" 
                                    :edicao="!anamnese"
                                    label="Fim" 
                                    type="time" />
                            </div>
                        </div>

                        <template v-if="!anamnese && !modelos">

                            <table class="table table-sm table-hover mt-2 small">
                                <thead>
                                    <tr>
                                        <th>
                                            <a href="#" @click.prevent="toggle_marcar_todos()">
                                                <span class="badge badge-secondary" title="Selecionados">{{ selecionados.length }}</span>
                                            </a>
                                        </th>
                                        <th>Horário</th>
                                        <th>Atend</th>
                                        <th>Paciente</th>
                                        <th>Procedimento</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in lista" :key="index" :class="item.selecionado ? 'table-success' : ''">
                                        <td>
                                            <input type="checkbox" v-model="item.selecionado" />
                                        </td>
                                        <td>{{ item.data.slice(11,16) }}</td>
                                        <td>#{{ item.id_atendimento }}</td>
                                        <td>{{ item.paciente.search }}</td>
                                        <td>{{ item.procedimento.search }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </template>

                        <template v-else>
                            <div class="row mt-3">
                                <div class="col col-12 col-md-3">
                                    <table class="table table-sm table-hover small">
                                        <thead> 
                                            <tr>
                                                <th>
                                                    Pacientes
                                                    <span class="badge badge-secondary" title="Selecionados">{{ selecionados.length }}</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, iix) in selecionados" :key="iix">
                                                <td>{{ item.paciente.search }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <template v-if="anamnese">

                                    <div class="col col-12 col-md-9">

                                        <div class="list-group">
                                            <button type="button" class="list-group-item list-group-item-action" @click="anamnese = null">Voltar</button>
                                        </div>

                                        <formulario
                                            :block_modelos="true"
                                            :compact="anamnese.modelo_prontuario ? anamnese.modelo_prontuario.fl_compact : false"
                                            :modelo_prontuario="anamnese.modelo_prontuario"
                                            :gutters="anamnese.modelo_prontuario ? anamnese.modelo_prontuario.fl_espaco_reduzido : false"
                                            :tamanhoform="anamnese.modelo_prontuario ? anamnese.modelo_prontuario.st_form_tamanho_padrao : ''"
                                            :validate="validate"
                                            v-model="anamnese.dados"
                                            mode="fixed"
                                            :view_with_print="false"
                                            :infopaciente="infopaciente">
                                        </formulario>
                                    </div>

                                </template>

                                <template v-else-if="modelos">

                                    <div class="col col-12 col-md-9">
                                        <div class="list-group">
                                            <button type="button" class="list-group-item list-group-item-action" @click="modelos = null">Voltar</button>
                                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(modelo, imx) in modelos" :key="imx" @click="selecionar_modelo_assistencia(modelo)">
                                                <div>
                                                    {{ modelo.modelo ? modelo.modelo.search : '?' }}
                                                </div>
                                                <div>
                                                    <span class="badge badge-secondary">#{{ modelo.id_modelo_prontuario }}</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                </template>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                        <template v-if="!anamnese && !modelos">
                            <az-submit :disabled="!selecionados || !selecionados.length" @click="selecionar">Selecionar</az-submit>
                        </template>

                        <template v-else-if="anamnese">
                            <button type="button" class="btn btn-danger" @click="anamnese = null" v-if="false">Voltar</button>
                            <az-submit @click="registrar()">Registrar</az-submit>
                        </template>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Formulario from './Formulario.vue';

export default { 
    data() {
        return {
            inicio: "",
            fim: "", 
            lista: [], 
            validate: false, 
            anamnese: null, 
            modelos: null, 
            inclusao: null,
            alteracao: null, 
        };
    },

    components: {
        AzInput,
        AzSubmit,
        Formulario,
    },

    props: ['assistencia', 'fila'], 

    computed: { 
        selecionados: function () { 
            return this.lista.filter(item => item.selecionado);
        }
    },

    methods: { 
        toggle_marcar_todos () { 
            let todos = this.lista.filter(item => item.selecionado).length == this.lista.length; 
            this.lista.forEach(item => item.selecionado = !todos);
        },

        selecionar_modelo_assistencia (modelo) { 
            this.anamnese = { 
                id_modelo_prontuario: modelo.id_modelo_prontuario,
                modelo_prontuario: modelo.modelo, 
                dados: modelo.modelo.estrutura, 
            };
        },

        selecionar () { 
            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'bloco_obter_formulario', 
                dados: { 
                    id_atds: this.selecionados.map(item => item.id_atendimento),
                    assistencia: this.assistencia,
                    inicio: this.inicio,
                    fim: this.fim,
                    id_fila_laudo: this.fila ? this.fila.id_fila_laudo : null
                }, 
                callback: (res) => { 
                    this.anamnese = res.anamnese;
                    this.modelos = res.modelos; 
                    this.validate = false; 
                }
            });
        },

        registrar () { 
            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'bloco_salvar', 
                dados: { 
                    id_atds: this.selecionados.map(item => item.id_atendimento),
                    inicio: this.inicio,
                    fim: this.fim,
                    id_modelo_prontuario: this.anamnese.id_modelo_prontuario,
                    dados: this.anamnese.dados,
                    assistencia: this.assistencia,
                    id_fila_laudo: this.fila ? this.fila.id_fila_laudo : null
                }, 
                modal: 'atendBlocoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        abrir(lista) { 
            this.anamnese = null; 
            this.modelos = null; 
            this.inicio = ""; 
            this.fim = ""; 
            this.validate = false; 

            console.log('lista', lista);

            if ( this.assistencia ) { 

                this.lista = _.cloneDeep(
                    lista.filter(item => item.id_atendimento && item.ch_estado_marcacao == 'A')
                        .map(item => ({
                            selecionado: false,
                            id_marcacao: item.id_marcacao,
                            id_atendimento: item.id_atendimento,
                            paciente: item.paciente,
                            data: item.dt_inicio,
                            procedimento: item.procedimento
                        }))
                );

            } else { 

                this.lista = _.cloneDeep(
                    lista.filter(item => item.marcacao && item.marcacao.id_atendimento && item.marcacao.item_status && item.marcacao.item_status.acao_id == 'ch')
                        .map(item => ({
                            selecionado: false,
                            id_marcacao: item.marcacao.id_marcacao,
                            id_atendimento: item.marcacao.id_atendimento,
                            paciente: item.marcacao.paciente,
                            data: item.marcacao.dt_inicio,
                            procedimento: item.marcacao.procedimento
                        }))
                );

            }

            $('#atendBlocoModal').modal('show');
        }
    }
}
</script>